<template>
  <div class="main">
    <div class="main_header">
      <div class="header_item">
        <el-button :size="size" icon="el-icon-search"  v-if="showButton('search')" @click="searchUrlInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="propInsert()">添加</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        stripe
        :data="urlList"
        height="100%"
        v-loading="loading">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="urlName" label="url名称" align="center"></el-table-column>
        <el-table-column prop="urlPath" label="url地址" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteUrlInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '添加' : '修改'"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="rule_form" label-width="auto">
        <el-form-item label="url名称：">
          <el-input v-model="ruleForm.urlName" clearable placeholder="请输入url名称"></el-input>
        </el-form-item>
        <el-form-item label="url地址：">
          <el-input v-model="ruleForm.urlPath" clearable placeholder="请输入url地址"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()"> 提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(),
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        urlList: [], // url列表信息
        asyncTitle: true, // 对话框title true: 添加 false: 修改
        asyncVisible: false,
        ruleForm: {}, // url信息表单
        rules: {}
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchUrlInfo(true);
    },
    methods: {
      // 查询Url列表信息
      searchUrlInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        this.loading = true;
        this.$api.System.searchUrlInfoList(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.urlList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 打开修改信息
      propUpdate(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$set(this.ruleForm, 'urlId', row.urlId);
        this.$set(this.ruleForm, 'urlName', row.urlName);
        this.$set(this.ruleForm, 'urlPath', row.urlPath);
      },
      // 删除url信息
      deleteUrlInfo(row) {
        this.$confirm("该操作将删除该url，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.System.deleteUrlInfo({urlId: row.urlId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchUrlInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.System.insertUrlInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchUrlInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.System.updateUrlInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchUrlInfo(true);
                this.$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },
      // 切换分页
      changePageNum(page) {
        this.pageNum = page;
        this.searchUrlInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchUrlInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>